import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	title: 'Review',
	continueButtonText: 'Confirm and Submit',
	description: 'Please confirm the details you’ve entered are correct before you continue.',
	reminder:
		'Remember that Bacs payments must be set up and authorised by 5.10pm to meet your planned submission and settlement dates.',
	AuthorisationHeader: 'Authorisation Required',
	AuthorisationBodyMsg:
		'Once you’ve confirmed the details are correct and you choose to continue, this payment will have to be authorised using one of our online security methods.',
	AuthorisationByUserSubTitle: 'This will need authorised by ',
	deadlineMissedTitle: 'Bacs deadline missed',
	deadlineMissedBody:
		'As this payment’s being submitted after 5.10pm, it’ll now be submitted and settled on the following dates:',
	deadlineMissedAcceptButton: 'Accept and submit payment',
	deadlineMissedGoBackButton: 'Go back',
	deadlineMissedCancelButton: 'Cancel payment',
	deadlineMissedSettlementDateLabel: 'Settlement date:',
	deadlineMissedSubmissionDateLabel: 'Submission date:',
	deadlineMissedConfirmCancel: 'Yes, cancel payment',
	deadlineMissedBackoutOfCancel: 'No, go back',
	sidebarBody: 'Authorisation required',
	authorisationSubTitle: 'This will need authorised once you continue.',
	changeAuthoriserButton: 'Change',
	selectAuthoriserButton: 'Select user to authorise',
	viewAuthoriserButton: 'View users who can authorise',
	authoriserValidationMessage:
		'Please select which user will provide authorisation before you confirm and submit your payment.',
};

const traObligateContent = {
	...content,
	AuthorisationHeader: 'Authorisation may be required',
	AuthorisationBodyMsg:
		'Once you’ve confirmed the details are correct and you choose to continue, any transactions that are highlighted may have to be authorised using one of our online security methods.',
	AuthorisationByUserSubTitle: 'This may need authorised by',
};

export const contentPropTypes = createContentPropTypes(content);

export default { content, traObligateContent };
